import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "lkth_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch (e) {
      /* storage unavailable */
    }
  }, []);

  const decide = (analytics) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ necessary: true, analytics, ts: Date.now() }));
    } catch (e) {
      /* ignore */
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/10 bg-[#0B1F3A]"
          role="dialog"
          aria-label="Cookie consent"
          data-testid="cookie-consent-banner"
        >
          <div className="container-x flex flex-col items-start gap-4 py-5 sm:flex-row sm:items-center">
            <Cookie className="h-5 w-5 shrink-0 text-blue-400" aria-hidden="true" />
            <p className="flex-1 text-sm leading-relaxed text-slate-300">
              We use essential cookies to make this website work, and optional analytics cookies to
              understand how it is used. See our{" "}
              <Link to="/cookie-policy" className="font-semibold text-blue-400 underline underline-offset-2">Cookie Policy</Link>.
            </p>
            <div className="flex shrink-0 gap-3">
              <button onClick={() => decide(false)} className="btn-ghost-light !px-5 !py-2.5" data-testid="cookie-consent-decline-btn">
                Decline optional
              </button>
              <button onClick={() => decide(true)} className="btn-primary !px-5 !py-2.5" data-testid="cookie-consent-accept-btn">
                Accept all
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
